// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Make Toast Fully Responsive */
.Toastify__toast {
  max-width: 90vw !important;
  word-break: break-word !important;
  padding: 12px 16px !important;
  border-radius: 10px !important;
  font-size: 0.95rem !important;
}

/* Toast Body Text */
.Toastify__toast-body {
  font-size: 0.9rem !important;
  line-height: 1.3rem !important;
  word-break: break-word !important;
  white-space: normal !important;
}

/* Tablet Responsive Toast */
@media (max-width: 768px) {
  .Toastify__toast {
    max-width: 90vw !important;
  }
}

/* Mobile Responsive Toast */
@media (max-width: 480px) {
  .Toastify__toast {
    max-width: 97vw !important;
    margin: 0 auto !important;
    font-size: 0.85rem !important;
    padding: 10px 14px !important;
    margin-bottom: 10px !important;
  }

  .Toastify__toast-body {
    font-size: 0.85rem !important;
  }

  .Toastify__close-button {
    transform: scale(0.8);
  }
  .Toastify__toast-container--top-right {
    top: 10px !important;
    right: 10px !important;
    left: 10px !important;
    width: auto !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/toastStyles.css"],"names":[],"mappings":"AAAA,gCAAgC;AAChC;EACE,0BAA0B;EAC1B,iCAAiC;EACjC,6BAA6B;EAC7B,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA,oBAAoB;AACpB;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,iCAAiC;EACjC,8BAA8B;AAChC;;AAEA,4BAA4B;AAC5B;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA,4BAA4B;AAC5B;EACE;IACE,0BAA0B;IAC1B,yBAAyB;IACzB,6BAA6B;IAC7B,6BAA6B;IAC7B,8BAA8B;EAChC;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,qBAAqB;EACvB;EACA;IACE,oBAAoB;IACpB,sBAAsB;IACtB,qBAAqB;IACrB,sBAAsB;EACxB;AACF","sourcesContent":["/* Make Toast Fully Responsive */\n.Toastify__toast {\n  max-width: 90vw !important;\n  word-break: break-word !important;\n  padding: 12px 16px !important;\n  border-radius: 10px !important;\n  font-size: 0.95rem !important;\n}\n\n/* Toast Body Text */\n.Toastify__toast-body {\n  font-size: 0.9rem !important;\n  line-height: 1.3rem !important;\n  word-break: break-word !important;\n  white-space: normal !important;\n}\n\n/* Tablet Responsive Toast */\n@media (max-width: 768px) {\n  .Toastify__toast {\n    max-width: 90vw !important;\n  }\n}\n\n/* Mobile Responsive Toast */\n@media (max-width: 480px) {\n  .Toastify__toast {\n    max-width: 97vw !important;\n    margin: 0 auto !important;\n    font-size: 0.85rem !important;\n    padding: 10px 14px !important;\n    margin-bottom: 10px !important;\n  }\n\n  .Toastify__toast-body {\n    font-size: 0.85rem !important;\n  }\n\n  .Toastify__close-button {\n    transform: scale(0.8);\n  }\n  .Toastify__toast-container--top-right {\n    top: 10px !important;\n    right: 10px !important;\n    left: 10px !important;\n    width: auto !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
